import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isLoadingGrades: false,
  isLoadingCursus: false,
  isLoadingImport: false,
  isLoadingAllStudents: false,
  isSuccess: false,
  isSuccessGrades: false,
  isSuccessCursus: false,
  isSuccessImport: false,
  isSuccessAllStudents: false,
  studentData: [],
  allStudentData: [],
  currentStudentData: [],
  cursusByStudentData: [],
  gradesByStudentData: [],
  gradesByCourseData: [],
  error: '',
  errorImport: '',
}

export const getCursusByStudent = createAsyncThunk(
  'student/getCursusByStudent',
  async ({ studentID, teacherID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/cursusByStudent`, {
        params: { matricule: studentID, id_ens: teacherID },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getStudentByID = createAsyncThunk(
  'student/getStudentByID',
  async ({ studentID, specialiteID, teacherID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/student`, {
        params: { matricule: studentID, id_spe: specialiteID, id_ens: teacherID },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getGradesByStudent = createAsyncThunk(
  'student/getGradesByStudent',
  async ({ studentID, specialityID, courseID, semesterID, teacherID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/gradesByStudent`, {
        params: {
          matricule: studentID,
          id_spe: specialityID,
          id_mat: courseID,
          id_sem: semesterID,
          id_ens: teacherID,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getStudentsBySpeciality = createAsyncThunk(
  'student/getStudentsBySpeciality',
  async ({ specialityID, teacherID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/studentsBySpeciality`, {
        params: { id_spe: specialityID, id_ens: teacherID },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStudentsBySpeciality.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getStudentsBySpeciality.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          studentData: action.payload,
          error: '',
        }
      })
      .addCase(getStudentsBySpeciality.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getStudentByID.pending, (state) => {
        return {
          isLoading: true,
          ...state,
        }
      })
      .addCase(getStudentByID.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          currentStudentData: action.payload,
          error: '',
        }
      })
      .addCase(getStudentByID.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getCursusByStudent.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getCursusByStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          cursusByStudentData: action.payload,
          error: '',
        }
      })
      .addCase(getCursusByStudent.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getGradesByStudent.pending, (state) => {
        return {
          ...state,
          isLoadingGrades: true,
        }
      })
      .addCase(getGradesByStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingGrades: false,
          //isSuccessGrades: true,
          gradesByStudentData: action.payload,
          error: '',
        }
      })
      .addCase(getGradesByStudent.rejected, (state, action) => {
        return {
          ...state,
          isLoadingGrades: false,
          //isSuccessGrades: false,
          error: action.error.message,
        }
      })
  },
})

export default studentSlice.reducer
